import React from 'react'
import { Row, Col, Button } from 'reactstrap'

export default function HomepageScreen() {
  return (
    <div style={{ backgroundColor: 'white' }}>
      <Row className="align-items-center text-center">
        <Col xs={1} />
        <Col xs={3} className="text-center">
          <img src={require('./images/logo.png')} style={{ paddingLeft: '20%', height: 'auto', maxWidth: '100%' }} />
        </Col>
        <Col xs={7}>
          <img src={require('./images/motto2.png')} style={{ height: 'auto', maxWidth: '100%' }} />
        </Col>
        <Col xs={1} />
      </Row>
      <Row>
        <Col>
          <img src={require('./images/block1.png')} style={{ height: 'auto', maxWidth: '100%' }} />
          <a href='/admin' style={{ position: 'absolute', right: '20%', bottom: '10%' }}>
            <img src={require('./images/startbtn.png')} style={{ maxHeight: '100%', maxWidth: '100%' }} />
          </a>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row className="align-items-center text-center">
            <Col xs={2} />
            <Col xs={8}>
              <div style={{
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: '#94D7E9',
                borderRadius: 10,
                padding: 30,
                margin: 20,
              }}>
                <Row className="align-items-center text-center">
                  <Col xs={4} style={{
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderColor: '#94D7E9',
                  }}>
                    <img src={require('./images/feature1.png')} style={{ height: 'auto', maxWidth: '100%' }} />
                  </Col>
                  <Col xs={4} style={{
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderColor: '#94D7E9',
                  }}>
                    <img src={require('./images/feature2.png')} style={{ height: 'auto', maxWidth: '100%' }} />
                  </Col>
                  <Col xs={4}>
                    <img src={require('./images/feature3.png')} style={{ height: 'auto', maxWidth: '100%' }} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <img src={require('./images/apps.png')} style={{ padding: 20, height: 'auto', maxWidth: '100%' }} />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={2} />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <img src={require('./images/footer.png')} style={{ padding: 20, height: 'auto', maxWidth: '100%' }} useMap='#footer' />
          <map name="footer">
            <area shape="rect" coords="324,36,716,153" alt="카페" href="https://cafe.naver.com/lovecareyou/4" target="_new" />
            <area shape="rect" coords="334,230,392,259" alt="홈" href="/" />
            <area shape="rect" coords="430,230,514,255" alt="(주)캐어유" href="http://careyou.org?ref=mdpr-footer" target="_new" />
            <area shape="rect" coords="548,230,704,255" alt="카페" href="https://cafe.naver.com/lovecareyou/4" target="_new" />
          </map>
        </Col>
      </Row>


    </div>
  )
}
